import { ActionEnum } from '../enum/action.enum';

export const shipmentActions: string[] = [
    ActionEnum.QUOTE_SHIPMENT,
    ActionEnum.SHIPMENT_SUBMIT,
    ActionEnum.SHIPMENT_SUBMIT_MULTI,
    ActionEnum.QUOTE_MULTI_SHIPMENT,
    ActionEnum.SHIPMENT_VOID,
    ActionEnum.SHIPMENT_VOID_MULTI
];
